import bremen from "./images/2_.jpg";
import wembley from "./images/wembley.webp";
import sinpar from "./images/sinpar.jpg";

const navList = [
	{ id: "1", name: "BREMEN", value: "Bremen", image: `${bremen}` },
	{ id: "2", name: "Wembley", value: "Wembley", image: `${wembley}` },
	{ id: "3", name: "SinPar", value: "Sinpar", image: `${sinpar}` },
];

const brandImages = { bremen, wembley, sinpar };

export { brandImages, navList };
